import { Chip } from '@medpacesoftwaredevelopment/designsystem';

interface WithAuthorizedAmounts {
    currency?: string | null;
    authorizedAmountPatientsCurrency?: number | null;
    authorizedAmountUsd?: number | null;
}

export function computeAuthorizedAmountPatientsCurrencyChip(
    expense: WithAuthorizedAmounts | null | undefined,
    patientPreferredCurrency: string | null
): Chip[] | null {
    if (!expense || !patientPreferredCurrency || patientPreferredCurrency === 'USD') return null;
    const expenseCurrency = expense.currency?.toUpperCase();
    if (expenseCurrency === patientPreferredCurrency) return null;
    if (expense.authorizedAmountPatientsCurrency == null) return null;
    const value = `${expense.authorizedAmountPatientsCurrency.toFixed(2)} ${patientPreferredCurrency} · patient`;
    return [{ value, ariaLabel: value, removable: false }];
}

export function computeAuthorizedAmountUSDChip(expense: WithAuthorizedAmounts | null | undefined): Chip[] | null {
    if (!expense || expense.currency?.toUpperCase() === 'USD') return null;
    if (expense.authorizedAmountUsd == null) return null;
    const value = `${expense.authorizedAmountUsd.toFixed(2)} USD · reporting`;
    return [{ value, ariaLabel: value, removable: false }];
}
